<template>
	<div class="trip-tile">
		<a :href="item.permalink + $root.$refs.searchResults.searchQuery()" target="_blank" rel="noopener noreferrer">
			<div class="image">
				<span class="arrow-left" @click.prevent="prevPhoto()">
					<i class="wa-icon-long-arrow-left"></i>
				</span>
				<span class="arrow-right" @click.prevent="nextPhoto()">
					<i class="wa-icon-long-arrow-right"></i>
				</span>

				<img class="first" :src="$cdn.giata + item.images[currentPhotoIndex] + '&width=' + imageSize.width + '&height=' + imageSize.height" :srcset="$cdn.giata + item.images[currentPhotoIndex] + '&width=' + imageSize.width + '&height=' + imageSize.height + ' 1x, ' + $cdn.giata + item.images[currentPhotoIndex] + '&width=' + (imageSize.width * 2) + '&height=' + (imageSize.height * 2) + ' 2x'" v-if="item.images[currentPhotoIndex]"/>
			</div>

			<div class="info">
				<span class="caption">
					<span class="type package">{{ 'general.types.packageTours.singularLabel' | trans }}</span>
					<span class="location">
						&bull;
						{{ item.location.city }}, {{ item.location.country }}
					</span>
				</span>

				<h4>
					{{ item.name }}
					<span class="stars" v-if="item.category > 0">
						<i class="fa fa-star" v-for="index in parseInt(item.category, 10)"></i>

						<i class="fa fa-star-half" v-if="item.category%1 > 0"></i>
					</span>
				</h4>

				<span class="price">
					{{ 'tiles.trip.from' | trans }} <strong>{{ item.price.amount | formatPrice }} &euro;</strong>
					<span class="duration">
						{{ 'tiles.trip.for' | trans}} {{ item.price.lengthOfStay }} {{ (item.price.lengthOfStay === 1 ? 'tiles.trip.day' : 'tiles.trip.days') | trans }} / {{ 'tiles.trip.perPerson' | trans }}
					</span>
				</span>

				<button type="button" class="btn btn-sm compare" :class="{ 'btn-outline-primary': !isInComparison, 'btn-primary': isInComparison }" @click.prevent="toggleInComparison()">
					<i class="fa fa-plus" v-if="!isInComparison"></i>
					<i class="fa fa-check" v-if="isInComparison"></i>
					Vergleichen
				</button>
			</div>
		</a>
	</div>
</template>

<script>
export default {
	props: ['item', 'imageWidth', 'imageHeight'],
	data: function() {
		return {
			imageSize: {
				width: this.imageWidth,
				height: this.imageHeight
			},
			currentPhotoIndex: 0
		}
	},
	mounted: function() {
	},
	computed: {
		isInComparison: function() {
			return this.$root.tripsInComparison.indexOf(this.item.references.giataCode) >= 0;
		}
	},
	methods: {
		nextPhoto: function() {
			this.currentPhotoIndex += (this.currentPhotoIndex + 1 < this.item.images.length ? 1 : 0);
		},
		prevPhoto: function() {
			this.currentPhotoIndex -= (this.currentPhotoIndex - 1 >= 0 ? 1 : 0);
		},
		toggleInComparison: function() {
			if (!this.isInComparison) {
				this.$root.tripsInComparison.push(this.item.references.giataCode);
			} else {
				var index = this.$root.tripsInComparison.indexOf(this.item.references.giataCode);
				this.$root.tripsInComparison.splice(index, 1);
			}
		}
	}
}
</script>